import { Component, Input, OnInit, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { ModalService } from 'src/app/core/services/modal/modal.service';
import { Location } from "@angular/common";
declare var dataLayer;

@Component({
    selector: 'app-popup-solicitudes-pendientes',
    templateUrl: './popup-solicitudes-pendientes.component.html',
    styleUrls: ['./popup-solicitudes-pendientes.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PopupSolicitudesPendientesComponent implements OnInit {

  @Input() idModal: string;
  @Input() textDescription: string;
  @Output() irASolicitudes: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private _MODAL: ModalService,
    private location: Location
  ) { }

  ngOnInit() { }

  public cerrarModal(): void {
    sessionStorage.setItem('popup_solicitudes_cerrado', 'true');
    this._MODAL.closeModal(this.idModal);
  }

  public irASolicitudesClick(): void {
    dataLayer.push({
      'event': 'ga_event',
      'eventName': 'pop_up',
      'seccion': 'Inicio',
      'page_path': this.location.path,
      'label': 'Tienes ajustes pendientes en el listado de tus solicitudes',
      'link_text': ["Mis Solicitudes", "Cerrar"],
    })
    sessionStorage.setItem('popup_solicitudes_cerrado', 'true');
    this.cerrarModal();
    this.irASolicitudes.emit(true);
  }
}